module.exports = __webpack_public_path__ + "img/agreement-info.222d0bfe.svg";